import '@babel/polyfill/noConflict';
import './vendor/modernizr';
import objectFitImages from 'object-fit-images';

import { AnimateObserver } from './lib/animate-observer';
import { Sticky } from './lib/sticky';
import { Trigger } from './lib/trigger';
import { Carousel } from './lib/carousel';
import { Map } from './lib/map';
import { SubMenu } from './lib/sub-menu';

objectFitImages();

const carousel = new Carousel();
carousel.init();

const animate = new AnimateObserver();
animate.init();

const sticky = new Sticky();
sticky.init();

const trigger = new Trigger();
trigger.init();

const map = new Map();
map.init();

const subMenu = new SubMenu();
subMenu.init();

// ENV Usage
console.log(process.env.APP_NAME)
